import Echo from "laravel-echo";

export const clearChatId = (phone: string | null): string => {
    return typeof phone === "string" ? phone.replace(/[^\w\s!?]/g, "") : "";
};

export const connectWebsocket = (userId: any) => {
    // @ts-ignore
    if (
        typeof window.io !== "undefined" &&
        ["production", "testing"].indexOf(process.env.REACT_APP_ENV ?? "") !== -1 &&
        process.env.REACT_APP_SOCKET_HOST
    ) {
        let api_token = localStorage.getItem("api_token");

        let headers: any = {};
        headers["Authorization"] = api_token;
        headers["UserId"] = process.env.REACT_APP_ENV + "-" + userId;

        const socketHost = process.env.REACT_APP_SOCKET_HOST!;
        const socketTls = process.env.REACT_APP_SOCKET_TLS ?? "https";
        const socketPort = process.env.REACT_APP_SOCKET_PORT ?? "6001";
        window.Echo = new Echo({
            broadcaster: "socket.io",
            host: `${socketTls}://${socketHost}:${socketPort}`,
            auth: {
                headers: headers,
            },
            authEndpoint: (process.env.REACT_APP_AUTH_URL ?? "") + "/broadcasting/auth",
            enabledTransports: ["ws", "wss"],
            transports: ["websocket", "polling", "flashsocket"],
        });
        // @ts-ignore
        window.Echo?.connector?.socket?.on("disconnect", () => {
            console.log("Соединение потеряно. Попытка переподключения...");

            // Здесь можно реализовать логику переподключения, например, через определенное время:
            setTimeout(() => {
                // @ts-ignore
                window.Echo?.connector?.socket?.connect();
            }, 5000); // Переподключиться через 5 секунд (вы можете настроить это значение)
        });

        // Обработчик события успешного подключения
        // @ts-ignore
        window.Echo?.connector?.socket?.on("connect", () => {
            console.log("Соединение восстановлено.");

            // Дополнительные действия после успешного переподключения, если необходимо.
        });

        // @ts-ignore
        window.Echo?.connector?.socket?.on("connect_error", (error) => {
            console.error("WebSocket Connection Error:", error);
        });
    }
};
